import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiRequest } from "@/network/apiClient";

export const useGetReminder = ({leadID}) => {
    const [lastReminder, setLastReminder] = useState(null)
    const [allReminders, setAllReminders] = useState(null)

    const fetchData = async() => {
        try{
            
            // Construct lead_id query parameter
            const queryParams = new URLSearchParams({
                lead_id: leadID
            })

            // Get Last Reminder
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_REMINDER.LAST_REMINDER}?${queryParams}`, 'GET')
            setLastReminder(result)

            // Get All Reminders
            const resultAll = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_REMINDER.ALL_REMINDERS}?${queryParams}`, 'GET')
            setAllReminders(resultAll)
        } catch (error) {
            console.error(error)
        }
    };
    
    useEffect(() => {
        fetchData()
    }, [leadID])
    
    return {lastReminder, allReminders, refetch: fetchData}
}
